var React = require('react');

function DifficultyLevelGreenPill (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("rect",{"fill":"#E7993B","width":"132","height":"67.35","rx":"32.31","key":0}),React.createElement("circle",{"fill":"#4CA252","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","cx":"65.91","cy":"33.75","r":"27.07","key":1})])));
}

DifficultyLevelGreenPill.defaultProps = {"role":"presentation","viewBox":"0 0 132 67.35"};

module.exports = DifficultyLevelGreenPill;

DifficultyLevelGreenPill.default = DifficultyLevelGreenPill;
